import { gql, OperationVariables } from "@apollo/client"
import { useQuery } from "@oysterhr/core"

import { Company } from "@oysterhr/schema"

export const PAYMENT_METHODS_COMPANY_GET_PAYMENT_METHODS_TRANSACTIONS = gql`
  query PaymentMethodsCompanyGetPaymentMethodsTransactions($companyId: ID!) {
    company(companyId: $companyId) {
      id
      countryCode
      paymentCurrencyCode
      directDebitSupported
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
          accountNumber
          routingNumber
          state
          requiresEsignatureAuthorization
          currencyCode
          verificationAttemptsCount
          purpose
          mandate {
            status
          }
        }
        ... on PaymentMethodStripeSepa {
          id
          accountHolderName
          accountNumber
          billingAddress {
            addressLine1
            addressLine2
            city
            countryCode
            postalCode
            region
          }
          routingNumber
          state
          requiresEsignatureAuthorization
          currencyCode
          primary
          purpose
          mandateUrl
          mandate {
            status
          }
        }
        ... on PaymentMethodStripeBacs {
          id
          accountNumber
          routingNumber
          state
          requiresEsignatureAuthorization
          currencyCode
          primary
          purpose
          mandateUrl
          mandate {
            status
          }
        }
        ... on PaymentMethodStripePad {
          id
          accountNumber
          routingNumber
          state
          requiresEsignatureAuthorization
          currencyCode
          primary
          purpose
          mandate {
            status
          }
        }
      }
      transactions {
        id
        invoiceName
        status
        amount
        amountCurrencyCode
        createdAt
        bankNumberLast4
      }
    }
  }
`

export const useCompanyPaymentMethods = (options: OperationVariables) =>
  useQuery<{ company: Company }>(PAYMENT_METHODS_COMPANY_GET_PAYMENT_METHODS_TRANSACTIONS, options)
